// extracted by mini-css-extract-plugin
module.exports = {"body":"Categories_body__2YZuv","categoriesContainer":"Categories_categoriesContainer__16sxJ","spinnerContainer":"Categories_spinnerContainer__2FgCk"};